import { UserRole } from "./user-role";
import { Language } from '../language';
import { Invest } from '@classes/invest/invest';
import { Provider } from './provider';

export class User {
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    id?: number;
    isEnabled?: boolean;
    createdAt?: Date;
    lastLogonDate?: Date;

    language: Language;
    role: UserRole;
    investments?: Invest[];
    provider: Provider;

    constructor(username: string, email: string, language: Language, role: UserRole, provider: Provider) {
        this.username = username.trim().replace(" ", "_");
        this.email = email.trim().toLowerCase();
        this.language = language;
        this.role = role;
        this.provider = provider;

        this.firstName = "";
        this.lastName = "";
    }
}
